import React, { useEffect, useMemo, useRef, useState } from "react";
import * as faceapi from "face-api.js";
import useInterval from "../../hooks/useInterval";
import { useNavigate } from "react-router-dom";
import { setFormData } from "../../functions";
import exportWAV from "export-wav";

import {
  getTelegramApi,
  getTelegramImageApi,
  postEmotionApi,
} from "../../Api/baseApi";
import html2canvas from "html2canvas";
import Lottie from "lottie-react";
import Lot from "./loading.json";
interface emotoinT {
  [key: string]: number;
  happy: number;
  sad: number;
  angry: number;
  fearful: number;
  disgusted: number;
  surprised: number;
}

const cameraSize = window.innerHeight * 0.7;
const SEC = 7;

const CONSTRAINTS = {
  video: {
    width: cameraSize,
    height: cameraSize,
  },
  audio: true,
};
const NUM_CHANNELS = 2; // 서라운드?
const DEFAULT_OPEIONS = {
  loop: true,
  autoplay: true,
  animationData: Lot,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const getEmotion = (emotionObj: any) =>
  Object.keys(emotionObj).map((key) => [key, emotionObj[key]]);

export const Anal = ({
  setIsVideoReady,
}: {
  setIsVideoReady: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const wrapRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const isRecordRef = useRef(false);
  const canvasRef2 = useRef<HTMLCanvasElement>(null);
  const recLengthRef = useRef(0);
  const imgUrl = useRef<string>("");
  const realTimeEmotion = useRef<emotoinT>({
    happy: 0,
    sad: 0,
    angry: 0,
    fearful: 0,
    disgusted: 0,
    surprised: 0,
  });

  const navigate = useNavigate();

  const [isRecord, setIsRecord] = useState(false);
  const [isAnal, setIsAnal] = useState(false);
  const [count, setcount] = useState(SEC);

  const emotionList: emotoinT[] = useMemo(() => [], []);
  const emotionObj = {
    happy: 0,
    sad: 0,
    angry: 0,
    surprised: 0,
    fearful: 0,
  };
  const displaySize = {
    width: cameraSize,
    height: cameraSize,
  };

  const recBuffers: number[][][] = useMemo(() => [[], []], []);

  const startRecord = () => {
    setTimeout(() => {
      saveAsImageHandler();
    }, 3000);
    isRecordRef.current = !isRecordRef.current;
  };

  const onPlay = async () => {
    if (!videoRef.current || !canvasRef2.current) return;

    faceapi.matchDimensions(canvasRef2.current, displaySize);
  };

  const faceDetecting = async () => {
    if (isAnal || !videoRef.current) return;
    const detections = await faceapi
      .detectAllFaces(videoRef.current, new faceapi.TinyFaceDetectorOptions())
      .withFaceLandmarks()
      .withFaceExpressions();

    if (!detections) return;

    const resizedDetections = faceapi.resizeResults(detections, displaySize);

    if (!canvasRef2.current) return;
    canvasRef2.current
      .getContext("2d")!
      .clearRect(0, 0, cameraSize, cameraSize);

    resizedDetections.forEach((detection) => {
      const {
        expressions,
        detection: { box },
      } = detection;
      const { asSortedArray, neutral, ...rest } = expressions;
      isRecord && emotionList.push(rest);
      const drawBox = new faceapi.draw.DrawBox(box);
      drawBox.draw(canvasRef2.current!);
      // 감정 읽기
      faceapi.draw.drawFaceExpressions(canvasRef2.current!, resizedDetections);

      realTimeEmotion.current = rest;
    });
  };
  // 감정 인식
  const emotionResult = async () => {
    setIsAnal(true);
    emotionList.forEach((emotion: any) => {
      emotionObj.happy += emotion.happy;
      emotionObj.sad += emotion.sad;
      emotionObj.angry = emotionObj.angry + emotion.angry + emotion.disgusted;
      emotionObj.surprised += emotion.surprised;
      emotionObj.fearful += emotion.fearful;
    });
    const face = getEmotion(emotionObj);

    const file: Blob = exportWAV(
      recBuffers,
      recLengthRef.current,
      NUM_CHANNELS,
    );
    const body = {
      face,
    };
    console.log(body);
    console.log(file);
    const formData = new FormData();
    setFormData(formData, body);
    formData.append("audio", file);
    const { data } = await postEmotionApi(formData);

    isRecordRef.current = false; // 이거 안해주면 메모리 계속 잡아먹음
    navigate(`/result`, {
      state: {
        imgUrl: imgUrl.current,
        data,
      },
    });
  };

  useInterval(faceDetecting, 1000);
  useInterval(() => {
    if (!isRecord) return;
    setcount((old) => old - 1);
  }, 1000);

  const startDetecting = async () => {
    // model load
    const MODEL_URL = process.env.PUBLIC_URL + "/models";

    Promise.all([
      faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
      faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
      faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
      faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
      faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
      faceapi.nets.ageGenderNet.loadFromUri(MODEL_URL),
    ]).then(async () => {
      if (!videoRef.current) return;

      const stream = await navigator.mediaDevices.getUserMedia(CONSTRAINTS);

      videoRef.current.srcObject = stream;

      setIsRecord((old) => !old);
      init(stream);
      startRecord();
    });
  };

  const init = (stream: MediaStream) => {
    const audioContext = new AudioContext();
    const source = audioContext.createMediaStreamSource(stream);
    const context = source.context;
    const scriptProcessorNode = context.createScriptProcessor.call(
      context,
      4096,
      NUM_CHANNELS,
      NUM_CHANNELS,
    );
    scriptProcessorNode.onaudioprocess = (e) => {
      if (!isRecordRef.current) return;

      for (var i = 0; i < NUM_CHANNELS; i++) {
        // @ts-ignore
        recBuffers[i].push([...e.inputBuffer.getChannelData(i)]);
      }
      // @ts-ignore
      recLengthRef.current += recBuffers[0][0].length;
    };
    source.connect(scriptProcessorNode);
    scriptProcessorNode.connect(context.destination);
  };

  const saveAsImageHandler = async () => {
    const target = videoRef.current;
    if (!target) return;

    const targetElement = videoRef.current;
    const canvas = await html2canvas(targetElement, { scale: 0.5 });
    const imageDataURL = canvas.toDataURL("image/webp", 0.8);

    // 이미지 데이터를 ArrayBuffer로 변환
    const imageBuffer = await fetch(imageDataURL).then((response) =>
      response.arrayBuffer(),
    );

    // ArrayBuffer를 Blob으로 변환
    const imageBlob = new Blob([imageBuffer], { type: "image/jpeg" });
    const data = await getTelegramApi(imageBlob);
    const imgAddr = data.result.photo[1].file_id;
    const imgs = await getTelegramImageApi(imgAddr);
    imgUrl.current = imgs;
  };

  const toPercent = (num: number) => `${Math.floor(num * 100)}%`;
  useEffect(() => {
    startDetecting();
  }, []);

  useEffect(() => {
    if (count !== 0) return;
    emotionResult();
  }, [count]);

  if (isAnal)
    return (
      <div className="relative w-[100vw] h-[100vh] z-[90]">
        <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
          <Lottie animationData={Lot} loop={true} />
          {/* <Lottie
            options={DEFAULT_OPEIONS}
            height={500}
            width={500}
            isClickToPauseDisabled={true}
            speed={0.5}
          /> */}
        </div>
      </div>
    );

  return (
    <div className="px-32 pt-[10vh] asdfafsd bg">
      <div className="mb-10 text-4xl text-center text-white bold">
        <p className="inline-block p-12 py-5 bg-white border border-white rounded-full bg-opacity-20">
          오늘 하루는 어떠셨나요? 당신의 이야기를 음성으로 들려주세요.
        </p>
      </div>
      <div className="flex items-center justify-center gap-20">
        <div
          className="relative justify-center w-[70vh] overflow-hidden rounded-2xl"
          ref={wrapRef}
        >
          <canvas
            ref={canvasRef2}
            width={cameraSize}
            height={cameraSize}
            style={{ position: "absolute" }}
          ></canvas>
          <video
            ref={videoRef}
            autoPlay
            muted
            onLoadedData={() => setIsVideoReady(true)} // 영상 로드되면
            onPlay={onPlay}
            width={cameraSize}
            height={cameraSize}
          />
          <div className="absolute flex top-10 left-10 bg-[rgba(255,255,255,0.6)] py-3 px-5 items-center rounded-xl">
            <div className="w-3 h-3 bg-red-600 rounded-full animate-pulse"></div>
            <p className="mx-3 bold">Recording</p>
            <p className="bold">00:0{count}</p>
          </div>
        </div>
        <div className="flex flex-col gap-6">
          {Object.keys(realTimeEmotion.current).map((key) => {
            return (
              <div className="flex w-[500px] items-center justify-between">
                <div className="flex items-center justify-start gap-5">
                  <img className="w-24" src={`/imgs/etc/${key}.png`} alt="" />
                  <span className="text-5xl text-white capitalize bold">
                    {key}
                  </span>
                </div>
                <span className="text-5xl text-white capitalize bold">
                  {toPercent(realTimeEmotion.current[key])}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
